import { render, staticRenderFns } from "./InvoiceRecipientAddressView.vue?vue&type=template&id=316c61ae&scoped=true&"
import script from "./InvoiceRecipientAddressView.vue?vue&type=script&lang=js&"
export * from "./InvoiceRecipientAddressView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c61ae",
  null
  
)

export default component.exports